import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course03 from "../../../course/course-03/course";
import course05 from "../../../course/course-05/course";
import lesson0309 from "../../course-03/lesson-09/lesson";
import lesson0311 from "../../course-03/lesson-11/lesson";
import lesson0503 from "../lesson-03/lesson";
import lesson0509 from "../lesson-09/lesson";
import lesson0515 from "../lesson-15/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "cb593ce1-4689-48f3-9aa7-f618424b3940",
    course: { id: course03.id, slug: course03.slug as string, name: course03.name, publicId: course03.publicId },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0309),
    lesson: lesson0309,
  },
  {
    id: "bea1775d-ea5a-4f82-9dbf-464375dd507b",
    course: { id: course03.id, slug: course03.slug as string, name: course03.name, publicId: course03.publicId },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0311),
    lesson: lesson0311,
  },
  {
    id: "8e63a275-2222-417e-bfe1-4ed896770518",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
  {
    id: "05461065-7bfa-450d-acfe-68b00c70ac74",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0509),
    lesson: lesson0509,
  },
  {
    id: "b3edf55d-72df-49dc-aaff-a760dd62c81f",
    course: { id: course05.id, slug: course05.slug as string, name: course05.name, publicId: course05.publicId },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0515),
    lesson: lesson0515,
  },
];

export default lessonLinks;
